module.exports = __webpack_public_path__ + "img/xbanner.9be467a0.jpg";